import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import {
  loginDrawerOverlayId,
  signupDrawerOverlayId,
  resetPasswordDrawerOverlayId,
} from "../constants";
import { useDrawerNavigation } from "../hooks/use-drawer-navigation";
import { useLoginForm } from "../hooks/use-login-form";
import { AuthDrawer } from "./AuthDrawer";
import { LoginForm } from "../forms/LoginForm";

export const LoginDrawer = () => {
  const translate = useTranslate();
  const { switchToDrawer, resetStateAfterClose } = useDrawerNavigation();

  const form = useLoginForm({
    onSuccess: () => {
      overlayEventEmitter.emit("close", { overlayId: loginDrawerOverlayId });
    },
  });

  const switchToSignup = (e: React.MouseEvent) => {
    e.preventDefault();
    resetStateAfterClose(() => {
      form.setEmail("");
      form.setPassword("");
    });
    switchToDrawer(signupDrawerOverlayId);
  };

  const switchToResetPassword = (e: React.MouseEvent) => {
    e.preventDefault();
    resetStateAfterClose(() => {
      form.setEmail("");
      form.setPassword("");
    });
    switchToDrawer(resetPasswordDrawerOverlayId);
  };

  return (
    <AuthDrawer
      overlayId={loginDrawerOverlayId}
      heading={translate("Account_Login_Drawer_Heading")}
    >
      <LoginForm
        form={form}
        forgotPasswordAction={
          <button
            type="button"
            onClick={switchToResetPassword}
            className="text-sm underline"
          >
            {translate("Account_Login_ForgotPassword")}
          </button>
        }
        signupAction={
          <ButtonAsButton
            label={translate("Account_Login_SecondaryAction")}
            onClick={(e) => {
              switchToSignup(e as React.MouseEvent);
            }}
            variants={{ style: "outline", width: "full" }}
          />
        }
      />
    </AuthDrawer>
  );
};
